import PixelBlast from '@/components/PixelBlast';
import HomeHeaderLogo from './home-header-logo';
import { AppDownloadButton } from '@/utils/app-download-button';
import { PhoneFrame } from '@/components/PhoneFrame';
import SplitText from '@/components/SplitText';
import paduPhone from '@/assets/images/newpaduscreen.png';

export function HomeHeader() {

    return (
        <div className="min-h-[80vh] bg-[#1a1a1a] relative overflow-hidden">
            {/* PixelBlast background */}
            <div className="absolute inset-0 z-0 opacity-40">
                <PixelBlast
                    variant="circle"
                    pixelSize={5}
                    color="#00d9d9"
                    patternScale={5}
                    patternDensity={1.2}
                    pixelSizeJitter={0}
                    enableRipples
                    rippleSpeed={0.4}
                    rippleThickness={0.22}
                    rippleIntensityScale={3}
                    liquid={false}
                    liquidStrength={0.12}
                    liquidRadius={1.2}
                    liquidWobbleSpeed={5}
                    speed={0.5}
                    edgeFade={0.25}
                    transparent
                />
            </div>

            {/* Content */}
            <div className="relative z-10 max-w-[1100px] mx-auto px-8 pt-28 lg:pt-40 pb-6 lg:pb-20 flex flex-col lg:flex-row items-center justify-center gap-6 lg:gap-12 lg:min-h-[80vh]">

                {/* Text column */}
                <div className="flex flex-col items-center lg:items-start text-center lg:text-left max-w-md">
                    <div className="animate-fadeIn [animation-fill-mode:both]">
                        <HomeHeaderLogo className="h-[140px]" />
                    </div>

                    <div className=" w-full text-center">
                        <SplitText
                            text="Κερδίζεις. Μόνο."
                            className="inline-block whitespace-nowrap text-[1.8rem] md:text-3xl lg:text-4xl leading-none font-bold text-[#00d9d9] font-roboto"
                            tag="p"
                            splitType="chars"
                            delay={30}
                            duration={0.8}
                            ease="power3.out"
                            from={{ opacity: 0, y: 40, rotate: 8 }}
                            to={{ opacity: 1, y: 0, rotate: 0 }}
                            threshold={0.1}
                        />
                    </div>

                    <p
                        className="mt-5 text-center text-white/60 text-base font-roboto animate-fadeIn animate-fadeIn-delay-600"
                    >
                        Το κορυφαίο app επιβράβευσης στην Ελλάδα που σε ανταμείβει σε κάθε αγορά!
                    </p>

                    <div className="mt-8 w-full flex justify-center animate-fadeIn animate-fadeIn-delay-800">
                        <AppDownloadButton className="hover:scale-105 transform transition-all duration-200 cursor-pointer font-bold px-10 py-4 rounded-full bg-[#00d9d9] text-black text-sm font-press-start" />
                    </div>
                </div>

                {/* Phone */}
                <div className="flex justify-center shrink-0 mt-16 lg:mt-0 phone-rise phone-rise-delay">
                    {/* <PhoneFrame width={210} float={false}>
                        <img
                            src={paduHomeScreen}
                            alt="PADU app home screen"
                            className="w-full h-full object-cover object-top scale-105 -translate-y-[4%] [transform-origin:top_center]"
                        />
                    </PhoneFrame> */}
                    <img
                        src={paduPhone}
                        alt="PADU app on phone"
                        className="w-[250px] h-auto lg:-translate-y-12"
                    />
                </div>
            </div>
        </div>
    );
}
